// src/lib/hooks/useMe.ts
import { useQuery } from '@tanstack/react-query';
import { fetchMe } from '@/lib/api/admin';
import type { MeData } from '@/types/admin';

export const meKeys = { all: ['me'] as const };

export const useMe = () => {
  return useQuery<MeData>({
    queryKey: meKeys.all,
    queryFn: fetchMe,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};
